export const MAX_VISIBLE_SHADES_COUNT = 5;
export const SEARCH_SHADE = 'search-shade';
